@if (show) {
    <span class="loader">
        <!--    <span [class.spinner]="!hideSpinner"></span>-->
        @if (!hideSpinner) {
            <i class="fa fa-spinner fa-spin-pulse" [ngClass]="iconSizeClass" data-qa="loading-spinner"></i>
        }
        @if (!hideLabel) {
            <span class="label" data-qa="loading-message">{{ label }}</span>
        }
    </span>
}
